'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { missingHeadshotCodes, playerCodes } from './_data';
import { initials, playerFromLabel } from './format';
export function PlayerTile(t0) {
  const $ = _c(36);
  const {
    label,
    tone
  } = t0;
  let accent;
  let code;
  let hasHeadshot;
  let player;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== label || $[1] !== tone) {
    player = playerFromLabel(label);
    code = playerCodes[player];
    let t5;
    if ($[10] !== code) {
      t5 = code && !missingHeadshotCodes.has(code);
      $[10] = code;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    hasHeadshot = t5;
    accent = tone === "draft" ? "text-[#8a3f31]" : "text-[#4b8065]";
    t4 = "group flex min-h-[76px] items-center gap-3 overflow-hidden border border-[#d7c9b7] bg-[#fffaf1] px-3 py-2 text-sm font-black transition hover:-translate-y-0.5 hover:shadow-[4px_4px_0_#24122f]";
    t3 = "relative flex h-14 w-12 shrink-0 items-end justify-center overflow-hidden border border-[#24122f] bg-[#eadfcf]";
    t1 = "absolute inset-0 flex items-center justify-center text-xs font-black text-[#24122f]/60";
    t2 = initials(player);
    $[0] = label;
    $[1] = tone;
    $[2] = accent;
    $[3] = code;
    $[4] = hasHeadshot;
    $[5] = player;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    accent = $[2];
    code = $[3];
    hasHeadshot = $[4];
    player = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
  }
  let t5;
  if ($[12] !== t1 || $[13] !== t2) {
    t5 = <span className={t1}>{t2}</span>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== code || $[16] !== hasHeadshot || $[17] !== player) {
    t6 = hasHeadshot && <Image src={`/fantasy/headshots/p${code}.png`} alt={`${player} headshot`} width={48} height={56} className="relative size-full object-contain object-bottom" onError={_temp} />;
    $[15] = code;
    $[16] = hasHeadshot;
    $[17] = player;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t3 || $[20] !== t5 || $[21] !== t6) {
    t7 = <div className={t3}>{t5}{t6}</div>;
    $[19] = t3;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== accent || $[24] !== label || $[25] !== player) {
    t8 = label !== player && <p className={`text-[11px] font-black uppercase ${accent}`}>{label.split(" ")[0]}</p>;
    $[23] = accent;
    $[24] = label;
    $[25] = player;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== player) {
    t9 = <p className="truncate font-sans text-base font-black">{player}</p>;
    $[27] = player;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t8 || $[30] !== t9) {
    t10 = <div className="min-w-0">{t8}{t9}</div>;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== t10 || $[33] !== t4 || $[34] !== t7) {
    t11 = <div className={t4}>{t7}{t10}</div>;
    $[32] = t10;
    $[33] = t4;
    $[34] = t7;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  return t11;
}
function _temp(event) {
  event.currentTarget.style.display = "none";
}